import LocalStorage from '../localstorage'

const localStorage = new LocalStorage();

const newPlayer = (context, player ) => {
    player.phase = 0
    player.points = 0
    context.commit('addPlayer', player)
};
const loadAvailableGames = (context) => {
    const availableGames = localStorage.loadGames();
    context.state.availableGames = availableGames;
};

const loadGame = (context, payload) => {
    const loadGame = context.getters.gameByName(payload.gameName)

    if(!loadGame) {
        return
    }

    loadGame.players.forEach(player => {
        context.commit('addPlayer', player)
    });

    context.commit('gameLoaded', loadGame.kartengeber)
};
  
const loadCurrentGame = (context) => {
    const currentGame = localStorage.getCurrentGame();

    if(currentGame.players) {
        currentGame.players.forEach(player => {
        context.commit('addPlayer', player)
        });
    }

    context.commit('gameLoaded', {kartengeber: currentGame.kartenGeber, gameStarted: currentGame.gameStarted})
};
const loadAutoSaveSettings = (context) => {
    const settings = localStorage.getAutoSave()
    context.commit('autoSaveSettingsLoaded', settings)
}

const startGame = (context) => {
    context.commit('startGame')
}

const endGame = (context) => {
    let players = context.state.players
    players.forEach(player => {
        context.commit('removePlayer', player)
    })
    context.commit('gameFinished')
}

const finishRound = (context, payload) => {
    for (const [name, status] of Object.entries(payload)) {
        const pointsToAdd = status.points
        const phaseDone = status.roundDone
        const playerName = name

        const player = context.getters.playerByName(playerName)

        player.points = player.points + pointsToAdd

        if (phaseDone) {
        player.phase++
        }

        context.commit('updatePlayer', player)
    }
    context.commit('finishRound')
}

const toggleEditMode = (context) => {
    context.commit('toggleEditMode')
}

const updatePlayer = (context, player) => {
    context.commit('updatePlayer', player)
}

const enableAutoSave = (context, gamename) => {
    context.commit('enableAutoSave', gamename)
}

export {
    newPlayer,
    loadAvailableGames,
    loadGame, 
    loadCurrentGame,
    loadAutoSaveSettings,
    startGame,
    endGame,
    finishRound,
    toggleEditMode,
    updatePlayer,
    enableAutoSave
  }